import { useEffect, useMemo, useState } from 'react';

import { PrismCode } from '../components/PrismCode';
import { Resource } from '../components/Resource';
import { fetchOrganisation } from '../network/fetchOrganisation';
import { useUser } from '../hooks/useUser';
import { default as Skeleton } from 'antd/es/skeleton';
import { type Organisation } from '../models/organisation';
import { InpayPrivateAndCertificatePairKeyModal } from '../components/InpayPrivateAndCertificatePairKeyModal';
import { generateCsrSubjData } from '../utils/generate-csr-subj-data-string';

export function IntroductionPage() {
  const [loadingOrgDetail, setLoadingOrgDetail] = useState(false);
  const [orgDetail, setOrgDetail] = useState<Organisation | undefined>(
    undefined
  );

  const { currentOrganisation } = useUser();

  useEffect(() => {
    const getOrgDetail = async () => {
      setLoadingOrgDetail(true);

      if (currentOrganisation) {
        const organisation = await fetchOrganisation(
          currentOrganisation.id.toString()
        );
        if (organisation?.data) {
          setOrgDetail(organisation?.data);
        }
      }
      setLoadingOrgDetail(false);
    };
    getOrgDetail();
  }, [currentOrganisation]);

  const csrSubjData = useMemo(() => {
    if (orgDetail) {
      return generateCsrSubjData({ org: orgDetail });
    } else {
      return "-subj /O='Atletico Nacional'/C='DK'/ST='Denmark'/L=''/";
    }
  }, [orgDetail]);

  if (loadingOrgDetail && currentOrganisation) return <Skeleton />;

  return (
    <div className="flex flex-col gap-6">
      <Resource resource={{ filePath: 'api/getting-started/introduction' }} />
      <div className="hint flex flex-1 flex-col gap-3">
        <p className="text-green-800">
          Hint: The following is a command to generate the SSL private key and
          CSR using OpenSSL utility.
        </p>
        <PrismCode
          showClipboard
          code={`openssl req -new -newkey rsa:4096 -nodes -keyout merchant-private.key -out merchant.csr ${csrSubjData}`}
        />
      </div>
      <div className="flex">
        <InpayPrivateAndCertificatePairKeyModal />
      </div>
    </div>
  );
}
